// MUI
import { Divider, Grid, Skeleton, Stack } from "@mui/material";

// Components
import TableLoader from "@Layouts/components/Skeletons/TableLoader";
import CollapseArea from "@Layouts/components/Basics/CollapseArea";

// Constants
const className = "rounded-lg";

export default function ReconciliationSkeleton() {
	return (
		<Stack>
			<Stack direction="row" justifyContent={"space-between"} alignItems={"center"} mt={3}>
				<Skeleton variant="text" width={550} height={50} className={className} />
				<Skeleton variant="text" width={145} height={50} className={className} />
			</Stack>
			<Grid container mt={1} mb={4} columnSpacing={6}>
				<Grid item xs={6}>
					<TableLoader bigTitle content rows={12} />
				</Grid>
				<Grid item xs={6}>
					<TableLoader bigTitle content rows={12} />
				</Grid>
			</Grid>
			<Divider />
			<Grid container mt={2.3} columnSpacing={6} component={"section"} mb={-2.3}>
				<Grid item xs={12} justifyContent="right" display={"flex"}>
					<Skeleton variant="text" width={210} height={50} className={className} />
				</Grid>
			</Grid>
			<CollapseArea title="Loading" collapsible loading={true}>
				Loading...
			</CollapseArea>
			<Divider />
			<CollapseArea title="Loading" collapsible loading={true}>
				Loading...
			</CollapseArea>
			<Divider />
			<CollapseArea title="Loading" collapsible loading={true}>
				Loading...
			</CollapseArea>
			<Divider />
			<CollapseArea title="Loading" collapsible loading={true}>
				Loading...
			</CollapseArea>
			<Divider />
			<CollapseArea title="Loading" collapsible loading={true}>
				Loading...
			</CollapseArea>
			<Divider className={"!mb-8"} />
			<Stack direction={"row"} spacing={2} width={"fit-content"}>
				<Skeleton variant="rectangular" width={120} height={20} className={"!rounded-xl"} />
				<Skeleton variant="text" width={200} height={20} />
			</Stack>
		</Stack>
	);
}
